import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  MenuItem,
} from '@mui/material';
import Loading from '../../components/loading';
import ModalErrorMessage from '../../components/modalErrorMessage/modalErrorMessage';
import { useIncomeActions } from '../hooks/useIncomeActions';

export default function ReceiptModal({ open, onClose, onSaveSuccess, onSaveError, incomeId }) {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [receiptMethodType, setReceiptMethodType] = useState('');

  const { receive: receiveIncome, isLoading } = useIncomeActions();

  const receive = () => {
    if (!receiptMethodType) {
      setShowErrorMessage(true);
      setErrorMessage('É obrigatório selecionar o tipo de Recebimento.');
      return;
    }

    const incomeToReceive = {
      receiptMethodType: receiptMethodType,
    };

    receiveIncome(incomeId, incomeToReceive)
      .then((returnFromApi) => {
        onSaveSuccess(returnFromApi);
      })
      .catch((returnFromApi) => {
        console.error('ops! ocorreu um erro' + returnFromApi);
        onSaveError(returnFromApi.response?.data);
      });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Receber</DialogTitle>
      <DialogContent>
        {showErrorMessage && (
          <ModalErrorMessage message={errorMessage} setShow={setShowErrorMessage} />
        )}
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Loading isToHidden={isLoading === false} />

          <Grid size={12}>
            <TextField
              select
              label="Tipo de Recebimento"
              value={receiptMethodType}
              onChange={(e) => setReceiptMethodType(e.target.value)}
              fullWidth
            >
              <MenuItem value="PIX">Pix</MenuItem>
              <MenuItem value="CREDIT_CARD">Cartão de Crédito</MenuItem>
              <MenuItem value="CASH">Dinheiro</MenuItem>
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button onClick={receive} variant="contained" disabled={isLoading}>
          Receber
        </Button>
      </DialogActions>
    </Dialog>
  );
}
